export const onlyAlphaNum = (str) => {
    return String(str ?? "")
        .replace(/[^0-9A-Za-z]/g, "")
        .toUpperCase();
};
export const onlyNumbers = (str) => {
    return String(str ?? "").replace(/[^0-9]/g, "");
};
export const limpaDocumento = (str) => {
    const alphaNum = onlyAlphaNum(str);
    const numeros = onlyNumbers(str);
    if (alphaNum.length <= 11 &&
        numeros.length === alphaNum.length &&
        /^[0-9]+$/.test(alphaNum)) {
        return numeros;
    }
    return alphaNum;
};
export const cnpjValorParaCalculo = (char) => {
    return char.toUpperCase().charCodeAt(0) - 48;
};
export const cnpjContemLetras = (cnpj) => {
    const limpo = onlyAlphaNum(cnpj);
    return /[A-Z]/.test(limpo.substring(0, 12));
};
export const validaCpf = (cpf) => {
    const apenasNumeros = onlyNumbers(cpf);
    if (apenasNumeros.length !== 11) {
        return false;
    }
    if (/^(\d)\1{10}$/.test(apenasNumeros)) {
        return false;
    }
    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(apenasNumeros.charAt(i)) * (10 - i);
    }
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    if (resto !== parseInt(apenasNumeros.charAt(9))) {
        return false;
    }
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(apenasNumeros.charAt(i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    return resto === parseInt(apenasNumeros.charAt(10));
};
export const validaCnpj = (cnpj) => {
    const limpo = onlyAlphaNum(cnpj);
    if (limpo.length !== 14) {
        return false;
    }
    if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(limpo)) {
        return false;
    }
    if (/^(.)\1{13}$/.test(limpo)) {
        return false;
    }
    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < 12; i++) {
        soma += cnpjValorParaCalculo(limpo.charAt(i)) * pesos1[i];
    }
    let resto = soma % 11;
    const d1 = resto < 2 ? 0 : 11 - resto;
    if (parseInt(limpo.charAt(12)) !== d1) {
        return false;
    }
    soma = 0;
    for (let i = 0; i < 13; i++) {
        soma += cnpjValorParaCalculo(limpo.charAt(i)) * pesos2[i];
    }
    resto = soma % 11;
    const d2 = resto < 2 ? 0 : 11 - resto;
    return parseInt(limpo.charAt(13)) === d2;
};
export const validaCpfCnpj = (documento) => {
    const limpo = limpaDocumento(documento);
    if (limpo.length === 11) {
        return validaCpf(documento);
    }
    if (limpo.length === 14) {
        return validaCnpj(documento);
    }
    return false;
};
export const formataCpfCnpj = (value) => {
    if (!value) {
        return value;
    }
    const alphaNum = onlyAlphaNum(value);
    const numeros = onlyNumbers(value);
    if (numeros.length === 11 &&
        alphaNum.length === 11 &&
        /^[0-9]+$/.test(alphaNum)) {
        return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    if (alphaNum.length === 14) {
        return alphaNum.replace(/(.{2})(.{3})(.{3})(.{4})(.{2})/, "$1.$2.$3/$4-$5");
    }
    if (numeros.length === 14) {
        return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
    return value;
};
const aplicarMascaraCpf = (valor) => {
    const limpo = onlyNumbers(valor).substring(0, 11);
    return limpo
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
};
const aplicarMascaraCnpj = (valor) => {
    const limpo = onlyAlphaNum(valor).substring(0, 14);
    return limpo
        .replace(/^(.{2})(.)/, "$1.$2")
        .replace(/^(.{2})\.(.{3})(.)/, "$1.$2.$3")
        .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, "$1.$2.$3/$4")
        .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.)/, "$1.$2.$3/$4-$5");
};
export const aplicarMascaraDocumento = (valor, tipo) => {
    const limpo = limpaDocumento(valor);
    if (tipo === "cpf") {
        return aplicarMascaraCpf(valor);
    }
    if (tipo === "cnpj") {
        return aplicarMascaraCnpj(valor);
    }
    if (limpo.length <= 11 && /^[0-9]+$/.test(limpo)) {
        return aplicarMascaraCpf(valor);
    }
    return aplicarMascaraCnpj(valor);
};
export const sanitizaEntradaDocumento = (valor, tipo) => {
    if (tipo === "cpf") {
        return onlyNumbers(valor);
    }
    if (tipo === "cnpj") {
        return onlyAlphaNum(valor);
    }
    const parcial = valor.replace(/[^0-9A-Za-z]/g, "");
    const numeros = onlyNumbers(parcial);
    if (numeros.length === parcial.length && parcial.length <= 11) {
        return numeros;
    }
    return parcial.toUpperCase();
};
if (typeof window !== "undefined") {
    window.DocumentoUtil = {
        onlyAlphaNum,
        onlyNumbers,
        limpaDocumento,
        cnpjValorParaCalculo,
        cnpjContemLetras,
        validaCpf,
        validaCnpj,
        validaCpfCnpj,
        formataCpfCnpj,
        aplicarMascaraDocumento,
        sanitizaEntradaDocumento,
    };
}
